<template>
  <form @submit.prevent="saveBroker(true)">
    <div>
      <div class="spinner-wrap" v-if="!dataIsLoaded">
        <Spinner />
      </div>
      <div class="content-wrap" v-else>
        <div class="content">
          <div class="brokers-wrap">
            <div class="form-header">
              <h3 class="brokers-title">Trip Report</h3>
              <div class="wrap-multiselect">
                <span class="label-multiselect">Please select Broker</span>
                <Multiselect
                  v-model="selectedBroker"
                  :options="allBrokers"
                  label="brokerName"
                  track-by="id"
                  :select-label="'Select'"
                  :deselect-label="'Remove'"
                  placeholder="Select a broker"
                  class="select-items"
                  @input="updateSelectedBroker"
                  @tag="createNewBroker"
                  taggable
                  tag-placeholder="Create new Broker"
                />
              </div>
            </div>

            <div class="form-questions" v-if="!selectedBroker">
              <div
                class="row"
                v-for="question of templatesQuestions"
                :key="question.id"
              >
                <div class="question-wrap">
                  <label :class="question.type"
                    >{{ question.question
                    }}<strong v-if="question.required"> *</strong></label
                  >
                  <div
                    class="question-input"
                    :class="question.type"
                    v-if="question.type !== 'File'"
                  >
                    <input type="text" class="form-control" disabled />
                  </div>
                  <div
                    class="question-input"
                    :class="question.type"
                    v-else-if="question.type === 'File'"
                  >
                    <input type="file" class="form-control" disabled />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import Spinner from "../../components/Spinner.vue";
import Multiselect from "vue-multiselect";

import {
  getTemplatesQuestions,
  createNewBrokerReport,
  getAllBrokers,
  createNewBroker
} from "@/api/brokers";

export default {
  name: "Broker",
  data: function() {
    return {
      broker: {},
      questions: [],
      dataIsLoaded: false,
      selectedBroker: null,
      allBrokers: {},
      templatesQuestions: {}
    };
  },
  components: {
    Spinner,
    Multiselect
  },
  async mounted() {
    if (this.$route.params.brokerId) {
      this.createNewBrokerReport(this.$route.params.brokerId);
    } else {
      await this.loadBroker();
    }
    
    window.scrollTo(0, 0);
  },
  watch: {},
  methods: {
    updateSelectedBroker(selectedBroker) {
      this.selectedBroker = selectedBroker;
      this.createNewBrokerReport(this.selectedBroker.id);
    },

    async createNewBroker(newBrokerName) {
      const newBroker = { 
        brokerName: newBrokerName,
        brokerDepartment: "Broker"
      };

      const response = await createNewBroker(newBroker);

      if (response.status_code === 200) {
        this.createNewBrokerReport(response.brokerId)
      } else {
        console.error("Error");
      }
    },

    async createNewBrokerReport(selectedBrokerId) {
      this.dataIsLoaded = false;

      const response = await createNewBrokerReport(selectedBrokerId);

      if (response && response.status_code === 200) {
        this.$router.push(
          `/brokers/${selectedBrokerId}/${response.brokerReportId}`
        );
      } else {
        console.error("Error");
      }

      this.dataIsLoaded = true;
    },

    async loadBroker() {
      this.$store.commit("header/setData", {
        title: ``,
        description: ``,
        showLogo: true,
        showLogoutBtn: false
      });

      this.dataIsLoaded = false;
      this.allBrokers = await getAllBrokers();
      this.templatesQuestions = await getTemplatesQuestions();
      this.dataIsLoaded = true;

      if (!this.broker) {
        console.error(`Broker with id ${this.$route.params.id} not found.`);
      }

      this.$store.commit("header/setData", {
        title: `Report for ${this.broker.brokerName}`,
        description: ``,
        showLogo: true,
        showLogoutBtn: false
      });
    }
  }
};
</script>

<style scoped>
.btn-primary {
  background-color: #007bff;
  color: #fff;
}

.spinner-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.content-wrap {
  display: flex;
  flex-direction: column;
}

.slider {
  background-color: #1e4775;
  padding: 20px;
  border-bottom: 1px solid #dee2e6;
}

.brokers-wrap {
  display: flex;
  flex-direction: column;

  padding: 0 1.5em 1.5em;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.content {
  max-width: 900px;
  margin: 0px auto 96px;
  width: 95%;
}

.brokers-wrap .header {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.brokers-wrap .header .row {
  display: flex;
  justify-content: space-between;
}

.brokers-wrap .content .row {
  margin-bottom: 20px;
}

.label-multiselect {
  display: block;
  margin-bottom: 3px;
  color: #0f2e50;
  font-size: 1.1em;
  font-weight: 600;
}

.question-wrap {
  display: flex;
  flex-direction: row;
  padding: 7px 1em;
  background: #efefef;
  font-weight: 500;
}

.question-wrap label {
  margin: auto;
  width: 51%;
  text-align: right;
  padding-right: 0.8em;
  color: #0f2e50;
  font-size: 1.3em;
}

strong {
  color: rgb(191, 30, 46);
}

.question-wrap input {
  padding: 10px;
  flex: 1;
  border: 1px solid white;
  font-family: "Poppins", sans-serif;
  font-size: 1.25em;
  cursor: pointer;
  outline: none;
  color: #333;
}

.question-wrap input:disabled {
  background-color: #fcfcfc;
  border-color: #fcfcfc;
}

/* .question-wrap input:hover {
		  border: 1px solid #0f2e50;
	  } */

/* .question-wrap input:focus {
		  border: 1px solid black;
	  } */

.question-input textarea {
  margin-bottom: 10px;
  padding: 10px;
  flex: 1;
  border: 1px solid white;
  font-family: "Poppins", sans-serif;
  font-size: 1.25em;
  cursor: pointer;
  outline: none;
  color: #333;
}

.question-input textarea:hover {
  border: 1px solid #0f2e50;
}

.question-input textarea:focus {
  border: 1px solid black;
}

.question-input,
.question-input input:not([type="radio"]),
.question-input textarea {
  width: 100%;
}

.File {
  width: 100%;
  margin-top: 5px;
}

.form-header {
  padding: 3em 0 0.7em;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.select-items {
  width: 300px;
}

.brokers-title {
  font-size: 1.5em;
  font-weight: 700;
  margin: 0;
}

.category-title {
  font-size: 1.5em;
  font-weight: 700;
  margin: 0;
  border-left: none;
  border-right: none;
}

.row:first-child .category-title {
  border-top: none;
}

.Header {
  font-size: 1.125em;
}

.question-wrap .Header {
  width: 100%;
  text-align: left;
}

.question-input .Radiobutton input[type="radio"] {
  margin-right: 10px;
}

.question-input .Radiobutton {
  padding-top: 0.25em;
}

.question-input .Radiobutton:first-child {
  padding-top: 0.65em;
}

.question-input .Radiobutton label {
  padding-top: 0;
  color: #333;
  color: #4e4e4e;
}

.c-head-btn {
  margin: 20px 0 10px 0;
}

.footer-wrap {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border-top: 1.5px solid #c9cacb;
}

.footer-wrap-content {
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
}

.footer-wrap .c-head-btn {
  width: fit-content;
}

select {
  width: 100%;
  padding: 10px;
  border: 1px solid white;
  font-family: "Poppins", sans-serif;
  font-size: 1.25em;
  background: white;
  cursor: pointer;
  outline: none;
  color: #333;
}

select:hover {
  border: 1px solid #0f2e50;
}

select:focus {
  border: 1px solid black;
}

select optgroup {
  font-weight: 700;
}

select optgroup:nth-of-type(1) {
  color: red;
}

select optgroup:nth-of-type(2) {
  color: blue;
}

select optgroup:nth-of-type(3) {
  color: green;
}

select optgroup:nth-of-type(4) {
  color: purple;
}

select optgroup:nth-of-type(5) {
  color: orange;
}

select optgroup:nth-of-type(6) {
  color: rgb(0, 255, 255);
}

select optgroup:nth-of-type(7) {
  color: brown;
}

select optgroup:nth-of-type(8) {
  color: pink;
}

select optgroup:nth-of-type(9) {
  color: black;
}

select option {
  color: black;
}

@media screen and (max-width: 768px) {
  .form-header {
    padding-top: 2em;
  }

  .category-title {
    font-size: 1.3em;
  }

  .question-wrap label {
    font-size: 1.1em;
  }

  .question-wrap input,
  .question-input textarea,
  select {
    font-size: 1.05em;
  }
}

@media screen and (max-width: 550px) {
  .form-header {
    flex-wrap: wrap;
    padding-top: 0.5em;
  }

  .multiselect.select-items {
    width: 100%;
  }

  .content {
    width: 100%;
    margin-bottom: 90px;
  }

  .brokers-title {
    padding: 1em 0 0.75em;
    font-size: 1.1em;
  }

  .question-wrap {
    flex-direction: column;
    padding: 0.2em 1em;
  }

  .question-wrap label {
    width: 100%;
    text-align: left;
    font-size: 1em;
    padding-top: 0.3em;
    margin-bottom: 5px;
  }

  .question-wrap input {
    margin-bottom: 5px;
    font-size: 1em;
  }

  select {
    font-size: 0.9em;
  }

  .question-input.File .form-control {
    font-size: 1em;
  }

  .c-head-btn {
    margin: 10px 0;
  }

  .footer-wrap-content {
    display: flex;
    justify-content: center;
  }
}
</style>

<style>
  .select-items .multiselect__placeholder {
    color: #0f2e50 !important;
  }
</style>
